<template>
  <div class=" section_sectionWrapper">
    <div class="module-role">
      <div class="title"></div>
      <div class="cha-cont">
        <div class=" w100 h100">
          <swiper :options="rolesilderOptions" ref="rolesilderOptions" class="role-swiper">
            <swiper-slide v-for="i in 8" :key="i">
              <div class="img-size ">
                <div class=" cha-img ani" swiper-animate-effect="bounceInLeft" swiper-animate-duration="1.2s"
                  swiper-animate-delay="0s">
                  <div class="cha-bg"></div>
                  <div class="role" :class="'role' + i"><img :src="require('../../assets/img/cha/cha' + i + '.png')"
                      alt="" srcset="">

                  </div>
                </div>
                <div class="detail-img ">
                  <div class="cha-img-size ani" :class="'cha-page-0' + i" swiper-animate-effect="bounceInRight"
                    swiper-animate-duration="1.2s" swiper-animate-delay="0s">
                    <div class="icon-video" @click="handleRoleVo(i)"></div>
                    <div class="icon-model-video" @click="handleModelVo(i)"></div>

                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" @click="stopAduio"></div>
          <div class="swiper-button-next" @click="stopAduio"></div>
          <!-- <div class="swiper-pagination-news" @click="stopAduio"></div> -->
          <!-- <div class="more"></div> -->
        </div>
      </div>
    </div>
    <!-- audio -->
    <audio controls="controls" ref="audio" id="nameAttrValue" style="display: none;">
      <source :src="musicUrl" type="audio/wav" />
    </audio>
  </div>
</template>
<script>
import * as swiperAni from "../../commonFunction/animate.js";
export default {
  name: 'app',


  data() {
    let that = this;
    return {
      musicUrl: "",
      rolesilderOptions: {
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: false,
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function () {
            swiperAni.swiperAnimateCache(this); //隐藏动画元素
            swiperAni.swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionStart: function () {
            swiperAni.swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          },
        },

      },
    }
  },
  watch: {


  },
  methods: {
    handleRoleVo(val) {
     
      let url = require(`../../assets/img/cha/audio/role-${val}.wav`);
      this.$refs.audio.src = url;
      let audio = this.$refs.audio;
      audio.load();
      audio.play();

      console.log('当前点击的音频', url)
    },
    // 滑动箭头的时候，音频不播放
    stopAduio() {
      let audio = this.$refs.audio;
      audio.pause();
    },
    handleModelVo(val) {
      console.log('现在点击的事', val)
      this.stopAduio()
      this.$emit('handleRoleVideo', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.module-role {
  position: relative;
  height: 100%;
  width: 100%;
  // width: 1920px;
  // height: 1080px;

  .title {
    width: 280px;
    height: 105px;
    background-size: 100% 100%;
    position: absolute;
    top: 109px;
    left: 50%;
    transform: translateX(-50%);
    background-image: url("../../assets/img/cha/title.png");
  }

  .role-swiper {
    // overflow: visible;
  }

  .cha-cont {
    width: 1484px;
    height: 800px;

    position: absolute;
    left: 50%;
    transform: translate(-50%, -60%);
    top: 72%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .img-size {
      position: relative;
      display: flex;
      align-items: start;
      gap: 32px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }

      .cha-img {
        width: 583px;
        height: 730px;
        position: relative;
        left: 86px;

        .cha-bg {
          width: 554px;
          height: 554px;
          background-size: 100% 100%;
          background-image: url("../../assets/img/cha/cha-bg.png");
        }

        .role {
          position: absolute;
          top: 0;
          width: 583px;
          height: 730px;

        }

        .role3 {
          right: -38px;
        }

        .role4 {
          left: -82px;
        }

        .role7 {
          width: 840px;
          height: 652px;
          left: -92px;
          top: 70px;
        }
      }

      .detail-img {
        position: relative;
        top: -42px;


        .cha-img-size {
          width: 901px;
          height: 799px;
          display: block;
          position: relative;
        }

        .cha-page-01 {
          background: url("../../assets/img/cha/cha-page-01.png") no-repeat top;
          background-size: 100% 100%;
        }

        .cha-page-02 {
          background: url("../../assets/img/cha/cha-page-02.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            right: 628px;
            top: 195px;
          }
        }

        .cha-page-03 {
          background: url("../../assets/img/cha/cha-page-03.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            right: 630px;
            top: 178px;
          }
        }

        .cha-page-04 {
          background: url("../../assets/img/cha/cha-page-04.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            right: 650px;
          }
        }

        .cha-page-05 {
          background: url("../../assets/img/cha/cha-page-05.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            top: 190px;
          }
        }

        .cha-page-06 {
          background: url("../../assets/img/cha/cha-page-06.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            top: 188px;
          }
        }

        .cha-page-07 {

          background: url("../../assets/img/cha/cha-page-07.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            top: 198px;
          }
        }

        .cha-page-08 {
          background: url("../../assets/img/cha/cha-page-08.png") no-repeat top;
          background-size: 100% 100%;

          .icon-video {
            top: 185px;
            right: 630px;
          }
        }

        .icon-video {
          background: url("../../assets/img/cha/icon-vo.png") no-repeat top;
          background-size: 100% 100%;
          width: 36px;
          height: 36px;
          position: absolute;
          top: 175px;
          right: 640px;
          z-index: 1;
        }


        .icon-model-video {

          width: 370px;
          height: 240px;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 1;
        }
      }

    }

    .swiper-button-prev:after {
      display: none;
    }

    .swiper-button-next:after {
      display: none;
    }

    .swiper-button-prev {
      background: url("../../assets/img/cha/arrow-lf.png") no-repeat top;
      background-size: 100% 100%;
      width: 30px;
      height: 35px;
      top: auto;
      bottom: 150px !important;
      left: 110px;
    }

    .swiper-button-next {
      background: url("../../assets/img/cha/arrow-lr.png") no-repeat top;
      background-size: 100% 100%;
      width: 30px;
      height: 35px;
      top: auto;
      right: 0;
      bottom: 150px !important;
    }



  }

}

@media screen and (max-width: 1200px) {
  .module-role {
    .cha-cont {
      top: 62% !important;

      .icon-video {
        right: 635px !important;

      }

      .cha-page-02 {
        .icon-video {
          right: 630px !important;
        }
      }

      .cha-page-04 {
        .icon-video {

          right: 655px !important;
        }
      }


      .icon-model-video {

        width: 333px !important;
        height: 216px !important;
        bottom: 30px !important;
        left: 20px !important;

      }

    }
  }
}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
  .module-role {
    .title {
      width: 249px !important;
      height: 94px !important;
    }

    .cha-cont {
      width: 1261px !important;
      height: 680px !important;
      transform: translate(-50%, -50%) !important;
      top: calc(51% + 120px) !important;

      .icon-video {
        right: 500px !important;
        top: 135px !important;
      }

      .cha-page-02 {
        .icon-video {
          top: 152px !important;
        }
      }

      .cha-page-04 {
        .icon-video {

          right: 520px !important;
        }
      }

      .cha-page-05,
      .cha-page-06,
      .cha-page-08 {
        .icon-video {
          top: 145px !important;
        }
      }

      .cha-page-07 {
        .icon-video {

          top: 155px !important;
        }
      }

      .icon-model-video {

        width: 333px !important;
        height: 216px !important;

      }

      .cha-img {
        width: 495px !important;
        height: 620px !important;
        left: 39px !important;


        .cha-bg {
          width: 443px !important;
          height: 443px !important;
        }

        .role {
          width: 466px !important;
          height: 584px !important;
        }


      }

      .cha-img-size {
        width: 720px !important;
        height: 640px !important;


      }
    }


  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/rolepage.vue